export default __webpack_public_path__ + "static/media/rusgo-mobile-1.e75b4eb9.png";